import { Jumbotron } from "react-bootstrap"

function ListaVacia({texto}) {
    return (
        <Jumbotron className="w-100">
            <p className="d-bock text-center">{texto}</p>
        </Jumbotron>
    )
}

export default ListaVacia